import useFetch from "./UseFetch";
import EditableDatable from "./EditableDatatable";

const unwrapRows = (payload) => {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload.value)) return payload.value;
  if (Array.isArray(payload.data)) return payload.data;
  return [];
};

const toDateInput = (value) => {
  if (!value) return "";
  const text = String(value);
  if (text.includes("0001-01-01") || text.startsWith("0001-")) return "";
  return text.slice(0, 10);
};

const ReadOnlyLines = ({
  apiUrl,
  token,
  columns,
  title,
  description = "",
}) => {
  const { data, loading, error } = useFetch(apiUrl || null, token);
  const dateFields = (columns || [])
    .filter((col) => col.type === "date")
    .map((col) => col.name);

  const rows = unwrapRows(data).map((line) => {
    const mapped = {
      ...line,
      systemId: line.systemId || line.id,
      systemSerialId: line.systemId || line.id,
    };
    dateFields.forEach((field) => {
      mapped[field] = toDateInput(line[field]);
    });
    return mapped;
  });

  if (loading) return <div className="express-list-status">Loading lines...</div>;
  if (error)
    return (
      <div className="express-list-status" style={{ color: "red" }}>
        Error: {error}
      </div>
    );

  return (
    <EditableDatable
      columns={columns}
      initialData={rows}
      universalDisabled
      AllowDelete={false}
      allowEmptyRows={false}
      LineDescription={title}
      SecondaryDescription={description}
      authToken={token}
      actions={[]}
    />
  );
};

export default ReadOnlyLines;
